import ICTDistrictType from '../enums/ICTDistrictType';
import { login } from '../store/auth/auth-actions';

export async function fetchGetAuth(url) {
    try {
        const res = await fetch(url, {
            credentials: "include",
        });
        if (res?.status === 401) {
            login();
            await wait(1000);
            return null;
        }

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`faild to fetch json url: ${url} with status: ${res && res.status}`)
        }
    }
    catch (err) {
        console.error("error in fetch json", url, err);
    }
}

export async function fetchStaticJson(url) {
    let notCacheNumber;
    let res;
    let link;
    try {
        notCacheNumber = Math.floor(new Date().getTime());
        link = `${url}?ver=${notCacheNumber}`
        res = await fetch(link)
        if (res?.status === 401) {
            login();
            await wait(1000);
            return null;
        }
        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`failed to fetch json url: ${url} with status: ${res && res.status}`);
        }
    }
    catch (err) {
        console.error("error in fetch json", url, err);
    }
}

export async function fetchPost(url, data) {
    let res, resJson;
    try {
        res = await fetch(
            url, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: data && JSON.stringify(data)
        });

        if (res?.status === 401) {
            login();
            await wait(1000);
            return null;
        }

        if (res) {
            resJson = await res.text();
            return {
                status: res.status,
                body: resJson,
                ok: res.ok
            };
        }
        else {
            throw new Error(`status from api ${res.status}`)
        }
    }
    catch (err) {
        console.error("error in postJson", url, err);
        return {
            status: res?.status,
            body: resJson,
            ok: res?.ok
        };
    }

}


export async function fetchGet(url, data) {
    let res, resJson;
    try {
        res = await fetch(
            url, {
            method: 'Get',
            credentials: "include"
        });
        if (res?.status === 401) {
            login();
            await wait(1000);
            return null;
        }
        if (res) {
            resJson = await res.json();
            return {
                status: res.status,
                body: resJson,
                ok: res.ok
            };
        }
        else {
            throw new Error(`status from api ${res.status}`)
        }
    }
    catch (err) {
        console.error("error in postJson", url, err);
        return {
            status: res?.status,
            body: resJson,
            ok: res?.ok
        };
    }

}


export const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const getYouTubeVideoId = (url = "") => {
    const regExp = /(?:youtube\.com\/(?:.*[?&]v=|embed\/)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
};

export const getYouTubeThumb = (url) => {
    const id = getYouTubeVideoId(url);
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
};

export const openInNewTab = (link) => {
    window.open(link, '_blank')
}

export const getUserSchoolProperty = (userDetails, property) => {
    if (!userDetails) return null;
    return userDetails.schools && userDetails.schools.length
        ? userDetails.schools[0][property]
        : userDetails.defaultSchool?.[property] ?? null;
};

export const getClassLabelKey = (num) => {
    return `class${num}`;
};

export const isInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

export const formatNumberWithCommas = (value) => {
    if (value === null || value === undefined || value === '')
        return '0';
    const num = typeof value === 'number' ? value : Number(value);
    if (isNaN(num))
        return String(value);
    return num.toLocaleString('en-US');
};

export const downloadTableAsCSV = (rows, columns, texts, fileName = 'table') => {
    if (!Array.isArray(rows) || rows.length === 0) return;

    // Create CSV headers
    const headers = columns.map(col => texts?.[col.text] || col.text || col.key);

    // Create CSV rows
    const csvRows = rows.map(row => {
        return columns.map(col => {
            const value = row[col.key];
            // Handle nested values and format for CSV
            if (value === null || value === undefined) return '';
            // Escape quotes and wrap in quotes if contains comma
            const stringValue = String(value);
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return stringValue;
        });
    });

    // Combine headers and rows
    const csvContent = [
        headers.join(','),
        ...csvRows.map(row => row.join(','))
    ].join('\n');

    // Add BOM for Hebrew support in Excel
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const schoolTableFormatExcel = (rows, columns, texts, fileName = 'table') => {
    if (!Array.isArray(rows) || rows.length === 0) return;

    const processedRows = rows.map(row => {
        const processedRow = { ...row };
        if (row.rankingScore !== null && row.rankingScore !== undefined) {
            processedRow.rankingScore = Number(row.rankingScore)?.toFixed(2);
        }
        // if (row.participantsCount !== undefined) {
        //     processedRow.participantsCount = `${row.participantsCount ?? 0}`;
        // }
        // if (row.studentCount !== undefined) {
        //     processedRow.studentCount = `${row.studentCount ?? 0}`;
        // }
        if (row.ictDistrictId !== null && row.ictDistrictId !== undefined) {
            const districtId = typeof row.ictDistrictId === 'string' ? parseInt(row.ictDistrictId, 10) : row.ictDistrictId;
            const districtKey = ICTDistrictType[districtId];
            processedRow.ictDistrictId = districtKey ? (texts?.[districtKey] || row.ictDistrictId || '') : (row.ictDistrictId || '');
        }
        return processedRow;
    });
    const simpleColumns = columns.map(col => ({
        key: col.key,
        text: col.text
    }));
    return { processedRows, simpleColumns };
};

export const removeWordsFromText = (text, wordsToRemove = []) => {
    if (!text || !wordsToRemove || wordsToRemove.length === 0)
        return String(text || '');
    let result = String(text);
    wordsToRemove.forEach(word => {
        if (word && word.trim()) {
            const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`\\s*${escapedWord}\\s*`, 'gi');
            result = result.replace(regex, ' ').trim();
        }
    });
    return result.replace(/\s+/g, ' ').trim();
};
export const formatScore = (score) => {
    if (score === null || score === undefined) return '-';
    const num = Number(score);
    if (isNaN(num)) return '-';
    if (num > 0 && num < 1) return '1';
    return Math.round(num).toLocaleString('he-IL');
};

export const isCharedi = () => window.config?.isCharedi === true;

export const getPageForUserRow = (rows, userRow, pageSize = 100) => {
    if (!userRow?.key || userRow?.value == null || !rows?.length)
        return 1;
    const userIndex = rows.findIndex((row) => String(row[userRow.key]) === String(userRow.value));
    if (userIndex === -1)
        return 1;
    return Math.floor(userIndex / pageSize) + 1;
};


// true when time left < minutes (e.g. under 10 min) — timer shows until 10:00, hides from 9:59
export const isAlreadyUnderMinutes = (targetDate, minutes = 10) => {
    if (!targetDate) return false;
    const diffMs = new Date(targetDate).getTime() - Date.now();
    if (diffMs <= 0) return true;
    return diffMs < minutes * 60 * 1000;
};
export const openFinalGame = (finalGameLink) => {
    // if (!finalGameLink)
    //     return;
    openInNewTab(finalGameLink);
};